// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4642":"css/admin-app.6826","8401":"css/app.6826"}[chunkId] + ".css";
};